import { useState } from "react";
import TrashIcon from "../../../../../../../../../../../../assets/svg/trash-icon";
import CircularLoader from "../../../../../../../../../../../../components/Loader/CircularLoader";
import { useUpdateSpecificAgentBreakMutation } from "../../../../../../../../../../../../redux/services/userManagementApi";
import { customToast } from "../../../../../../../../../../../../utils/custom-toast/custom-toast";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../../../../../../redux/store";

interface LeaveActionPopUpProps {
  popupRef: React.RefObject<HTMLDivElement>;
  leaveId: string;
  startDate: string;
  endDate: string;
  onClose: () => void;
}

export const LeaveActionPopUp = ({
  popupRef,
  leaveId,
  startDate,
  endDate,
  onClose,
}: LeaveActionPopUpProps) => {
  const { userIdForEditOrView } = useSelector(
    (state: RootState) => state?.userManagement
  );
  const [deleteSpecificAgentBreak] = useUpdateSpecificAgentBreakMutation();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteLeave = async () => {
    setIsDeleting(true);
    try {
      await deleteSpecificAgentBreak({
        userId: userIdForEditOrView || "",
        breakId: leaveId,
        start_date: startDate,
        end_date: endDate,
        is_deleted: true,
      });
      customToast("Leave deleted successfully", "success");
      onClose();
    } catch (error) {
      const errorDetail =
        error && typeof error === "object" && "data" in error
          ? (error.data as { detail?: string })?.detail
          : undefined;
      customToast(errorDetail || "Failed to delete leave", "error");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div
      ref={popupRef}
      className="absolute -right-[123px] top-9 z-50 w-[150px] transition-all duration-200"
      data-popup-content
      role="menu"
      aria-label="Leave actions"
    >
      <div className="flex flex-col gap-[4px] py-[12px] px-[12px] bg-popper-bg dark:bg-popper-bg-dk backdrop-blur-[10px] border border-border-gray dark:border-border-gray-dk rounded-[8px] shadow-popper-blur-effect">
        <button
          onClick={() => !isDeleting && handleDeleteLeave()}
          className={`flex items-center gap-[4px] p-[8px] rounded-lg transition-colors duration-200 focus:outline-none focus:bg-hover-effect dark:focus:bg-hover-effect-dk ${
            isDeleting ? "cursor-wait opacity-80" : "cursor-pointer"
          }`}
          role="menuitem"
          disabled={isDeleting}
        >
          {isDeleting ? (
            <div className="flex items-center gap-1.5 text-verba-red-alert dark:text-verba-red-alert-dk">
              <CircularLoader size={14} />
              <span className="text-md font-medium">Deleting</span>
            </div>
          ) : (
            <>
              <TrashIcon className="w-[18px] h-[18px] text-verba-red-alert dark:text-verba-red-alert-dk" />
              <span className="text-md font-medium text-verba-red-alert dark:text-verba-red-alert-dk">
                Delete Leave
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
